import React from "react";

import SparkAiIcon from "../../../../../resources/sparkai.svg";
import { useRouteBuilder } from "../context/RouteBuilderContext";

/** Routes-page control that opens the generate-routes setup modal. */
export default function GenerateRoutesControl({
  onOpenSetup,
  showNotice,
}: {
  onOpenSetup: () => void;
  /** Disables the button while the out-of-credits notice shows. */
  showNotice: boolean;
}) {
  const { isBusy } = useRouteBuilder();
  const disabled = isBusy || showNotice;

  return (
    <div className="ml-4 flex" data-testid="generate-routes-control">
      <button
        type="button"
        data-testid="generate-routes-open-button"
        className={`inline-flex items-center gap-1.5 rounded-xl bg-snow-green px-4 py-2.5 text-sm font-bold text-snow-white ${
          disabled
            ? "cursor-not-allowed opacity-60"
            : "hover:opacity-80 active:opacity-40"
        }`}
        disabled={disabled}
        onClick={onOpenSetup}
      >
        <img src={SparkAiIcon} alt="" className="size-4" />
        Generate Routes
      </button>
    </div>
  );
}
